import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "motorway-svg-fill",
    fill: "#FFF",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 9.75H19.716a5.502 5.502 0 00-10.432 0H6v3h3.143a5.502 5.502 0 0010.714 0H42v-3zM12 11.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm16.284 14H6v-3h22.143a5.502 5.502 0 0110.714 0H42v3h-3.284a5.502 5.502 0 01-10.432 0zm5.216-4.25a2.5 2.5 0 110 5 2.5 2.5 0 010-5zM14.5 31a5.502 5.502 0 015.293 4H42v3H19.793a5.502 5.502 0 01-10.586 0H6v-3h3.207a5.502 5.502 0 015.293-4zM12 36.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0z"
  })));
}

export { SvgFilter as S };
